// extracted by mini-css-extract-plugin
var _1 = "buttonsWrapper__vUR6T";
var _2 = "headerContainer__WPOBh";
var _3 = "headerWrapper__mIBut";
var _4 = "left__r88Cq";
var _5 = "mainButton__CFIbi";
var _6 = "right__fxrwJ";
export { _1 as "buttonsWrapper", _2 as "headerContainer", _3 as "headerWrapper", _4 as "left", _5 as "mainButton", _6 as "right" }
export default { "buttonsWrapper": _1, "headerContainer": _2, "headerWrapper": _3, "left": _4, "mainButton": _5, "right": _6 }
